import styled from '@emotion/styled'
import { Button } from '@mui/material'

import { theme } from 'styles/theme/hav-theme'

import { shouldForwardProp } from 'commons/utils/mui'

type ActionButtonProps = {
  fill?: boolean
}

export const TableWrapper = styled.div`
  display: grid;
  background: ${theme.colors.neutral.white};
  width: 100%;
  padding: ${theme.spacing.xm};
  box-shadow: 0px 0px 6px rgba(92, 92, 92, 0.102);
  border-radius: ${theme.shapes.borderRadius.md};
`

export const ActionsLabel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ActionsCell = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacing.xs};
`

export const ActionButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  height: ${theme.spacing['2xm']};
  width: ${theme.spacing['2xm']};
  border-radius: ${theme.shapes.borderRadius.sm};
`

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: 0;
  height: ${theme.spacing['2xm']};
  width: ${theme.spacing['2xm']};
`

export const ApproveButton = styled(ActionButton)`
  background: ${theme.colors.alert.success.dark};
  :disabled {
    background: ${theme.colors.neutral.lighthover};
    cursor: not-allowed;
  }
`

export const RejectButton = styled(ActionButton)`
  background: ${theme.colors.alert.danger.dark};
  :disabled {
    background: ${theme.colors.neutral.lighthover};
    cursor: not-allowed;
  }
`

export const ApprovalStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    path {
      fill: ${theme.colors.primary.main};
    }
  }
`

export const FooterDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: ${theme.spacing.sm};
  padding-top: ${theme.spacing.sm};
  border-top: 1px solid ${theme.colors.neutral.lighthover};
`

export const FooterInfo = styled.span`
  color: ${theme.colors.neutral.high};
  font-size: ${theme.typography.sizes['2xs']};
`

export const FooterRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding-top: ${theme.spacing.md};
`

export const FooterActions = styled.div`
  display: flex;
  gap: ${theme.spacing.md};

  @media screen and (max-width: ${theme.breakpoints.md}px) {
    flex-direction: column-reverse;
  }
`

export const ApprovalActions = styled.div`
  display: flex;
  gap: ${theme.spacing.md};

  border-left: 1px solid ${theme.colors.neutral.lighthover};
  padding-left: ${theme.spacing.md};

  @media screen and (max-width: ${theme.breakpoints.md}px) {
    border: none;
    padding: 0;
  }
`

export const FooterButton = styled(Button, { shouldForwardProp })<ActionButtonProps>`
  border: 0;
  outline: none;
  padding: 0 24px;
  height: ${theme.spacing.xl};
  border-radius: ${theme.shapes.borderRadius.sm};
  font-family: ${theme.typography.family.bold};
  font-weight: ${theme.typography.weight.lg};
  font-size: ${theme.typography.sizes.xs};
  line-height: ${theme.typography.lineHeight.sm};
  background: ${({ fill }) => (fill ? theme.colors.primary.main : 'transparent')};
  color: ${({ fill }) => (fill ? theme.colors.neutral.white : theme.colors.primary.main)};
  transition: background 0.2s ease-in-out;

  :hover {
    background: ${({ fill }) =>
      fill ? theme.colors.primary.hover : theme.colors.neutral.lighthover};
  }
  :disabled {
    background: ${theme.colors.neutral.lighthover};
    cursor: not-allowed;
  }

  @media screen and (max-width: ${theme.breakpoints.md}px) {
    align-self: flex-end;
  }
`

export const WarningText = styled.strong`
  color: ${theme.colors.alert.warning.darker};
  font-weight: ${theme.typography.weight.lg};
`

export const WrapClockIcon = styled.div`
  display: flex;
  justify-content: center;
`

export const WrapIcon = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
`
